// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u9B1V","delete":"styles_delete__3dm07","update":"styles_update__23OfJ","add":"styles_add__3dBDv"};